import {Repository} from '@s-ui/domain'

export default class PaginationRepository extends Repository {
  /**
   * @param {Object} deps
   * @param {Function} deps.newsPaginationValueObjectFactory
   * @param {Object} deps.newsSearchUrlBuilder
   */
  constructor({newsPaginationValueObjectFactory, newsSearchUrlBuilder}) {
    super()

    this._newsPaginationValueObjectFactory = newsPaginationValueObjectFactory
    this._newsSearchUrlBuilder = newsSearchUrlBuilder
  }

  _getPreviousUrl({searchNewsVo, category, tag, page, searchTerm, section}) {
    return searchNewsVo.isFirstPage()
      ? Promise.resolve('')
      : this._newsSearchUrlBuilder.execute({
          category,
          tag,
          page: page - 1,
          searchTerm,
          section
        })
  }

  _getNextUrl({searchNewsVo, category, tag, page, searchTerm, section}) {
    return searchNewsVo.isLastPage()
      ? Promise.resolve('')
      : this._newsSearchUrlBuilder.execute({
          category,
          tag,
          page: page + 1,
          searchTerm,
          section
        })
  }

  /**
   * @return {Promise<Object, Error>} returns the urls for pagination
   */
  getPagination({searchNewsVo, category = '', tag = '', searchTerm = '', page = 1, section}) {
    const previousUrl = this._getPreviousUrl({
      searchNewsVo,
      category,
      tag,
      page,
      searchTerm,
      section
    })
    const nextUrl = this._getNextUrl({
      searchNewsVo,
      category,
      tag,
      page,
      searchTerm,
      section
    })

    return Promise.all([previousUrl, nextUrl]).then(([previous, next]) =>
      this._newsPaginationValueObjectFactory({previous, next})
    )
  }
}
